module.exports = ".row{margin-bottom:5px}\n"